const selects = document.querySelectorAll('.mega-list__select');

document.addEventListener('DOMContentLoaded', () => {
  selects.forEach((el) => {
    el.addEventListener('change', (event) => {
      const id = el.getAttribute('data-id');
      const parent = document.querySelector('.mega-list[data-id="' + id + '"]');
      const body = parent.querySelector('.mega-list__body');
      const val = el.value;
      let active = true;
      if (val.length) {
        active = true;
        parent.classList.add('mega-list--open');
      } else {
        active = false;
        parent.classList.remove('mega-list--open');
      }
      parent.setAttribute('aria-expanded', String(active));
      body.setAttribute('aria-hidden', String(!active));
      body.hidden = !active;

      // diagnosis service filter
      if (id === 'diagnosis') {
        const items = parent.querySelectorAll('.mega-list__list-item');
        let count = 1;
        items.forEach((item) => {
          const cats = item.getAttribute('data-cats');
          const active = cats.search('/|' + val + '|/') !== -1;
          item.setAttribute('aria-hidden', String(!active));
          item.hidden = !active;
          if (count <= 2) item.classList.add('mega-list__list-item--first');
          else item.classList.remove('mega-list__list-item--first');
          if (active) count++;
        });
      }

      // diagnosis service filter
      if (id === 'service') {
        const items = parent.querySelectorAll('.mega-list__content');
        items.forEach((item) => {
          const id = item.getAttribute('data-id');
          const active = parseFloat(id) === parseFloat(val);
          item.setAttribute('aria-hidden', String(!active));
          item.hidden = !active;
        });
        const itemsAside = parent.querySelectorAll('.mega-list__aside');
        itemsAside.forEach((item) => {
          const id = item.getAttribute('data-id');
          const active = parseFloat(id) === parseFloat(val);
          item.setAttribute('aria-hidden', String(!active));
          item.hidden = !active;
        });
      }
    });
  });
});
